export class AppUrl {
  public static baseWebUrl: string = "https://staging.lcm-client.com";
  public static portalWebUrl: string =
    "https://portal.obsolescence-management.net";
  public static ocWebUrl: string = "https://app.obsolescence.com";
  public static dbWebUrl: string = "https://db.am-client.com";
}

export class ContactUrl {
  public static baseContactUrl: string = "https://lcm-client.com";
  public static portalContactUrl: string =
    "https://www.obsolescence-management.net";
  public static ocContactUrl: string = "https://www.obsolescence.com";
}
